import React, { Component } from "react";
import { Show, TextField } from "admin-on-rest";

import { MarketerShowActions, BankField, FullNameField } from "./Create";
import MarketerShowLayout from "./MarketerShowLayout";
import FormRequestCommission from "./form/FormRequestCommission";
class MarketerCustomShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showButtonAdjust: 0,
      itemTransaction: []
    };
  }

  handleClose = status => {
    this.setState({ open: false, showButtonAdjust: 1 });
    if (status === "success") {
      window.location.reload();
    }
  };
  onShowDialog = () => {
    this.setState({ open: true });
  };

  setShowButtonAdjust = value => {
    this.setState({ showButtonAdjust: value });
  };

  render() {
    return (
      <div>
        <Show
          {...this.props}
          actions={
            <MarketerShowActions
              {...this.props}
              onShowDialog={value => this.onShowDialog(value)}
              isShowAdjust={this.state.showButtonAdjust}
            />
          }
        >
          <MarketerShowLayout
            {...this.props}
            setShowButtonAdjust={value => this.setShowButtonAdjust(value)}
            selectedDefault={this.state.showButtonAdjust}
            itemTransaction={this.state.itemTransaction}
          >
            <FullNameField
              source="lastName"
              style={{ paddingTop: 8, textAlign: "center" }}
            />
            <TextField
              source="google_email"
              label=""
              style={{ paddingTop: 8, textAlign: "center" }}
              addLabel={false}
            />
            <TextField
              source="mobile"
              label=""
              style={{ paddingTop: 8, textAlign: "center" }}
              addLabel={false}
            />
            <BankField
              source="bank_account"
              style={{ paddingTop: 8, textAlign: "center" }}
            />
          </MarketerShowLayout>
        </Show>
        <FormRequestCommission
          open={this.state.open}
          handleClose={this.handleClose.bind(this)}
          match={this.props.match}
        />
      </div>
    );
  }
}

export default MarketerCustomShow;



// WEBPACK FOOTER //
// ./src/marketers/MarketerCustomShow.js